import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getReq, postReq } from "../api.services";
// Assuming postReq is available from a common api service
// import { postReq } from "../../api.services";

export const getPaymentRequestDetails = createAsyncThunk(
  "payment_request/details",
  async (payload) => {
    const response = await getReq(
      `${process.env.REACT_APP_API_PUBLIC_V1}/payment_requests/${payload}`,
    );
    return response;
  },
);

export const createPaymentRequest = createAsyncThunk(
  "payment_request/create",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await postReq(
        `${process.env.REACT_APP_API_PUBLIC_V1}/payment_requests/${payload.publicId}/pay`,
        { ...payload, platform: "web" },
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

const paymentRequestSlice = createSlice({
  name: "paymentRequest",
  initialState: {
    getPaymentRequestDetailsObj: {
      status: "idle",
      data: null,
      successMessage: null,
      errorMessage: null,
    },
    createPaymentRequestObj: {
      status: "idle",
      data: null,
      successMessage: null,
      errorMessage: null,
    },
  },
  extraReducers: {
    [getPaymentRequestDetails.pending]: (state) => {
      state.getPaymentRequestDetailsObj.status = "pending";
    },
    [getPaymentRequestDetails.fulfilled]: (state, action) => {
      const { data, message } = action.payload;
      state.getPaymentRequestDetailsObj.status = "succeeded";
      state.getPaymentRequestDetailsObj.data = data;
      state.getPaymentRequestDetailsObj.successMessage = message;
    },
    [getPaymentRequestDetails.rejected]: (state, action) => {
      const { message } = action.error;
      state.getPaymentRequestDetailsObj.status = "rejected";
      state.getPaymentRequestDetailsObj.errorMessage = message;
    },
    [createPaymentRequest.pending]: (state) => {
      state.createPaymentRequestObj.status = "pending";
    },
    [createPaymentRequest.fulfilled]: (state, action) => {
      const { data, message } = action.payload;
      state.createPaymentRequestObj.status = "succeeded";
      state.createPaymentRequestObj.data = data;
      state.createPaymentRequestObj.successMessage = message;
    },
    [createPaymentRequest.rejected]: (state, action) => {
      const { message } = action.error;
      state.createPaymentRequestObj.status = "rejected";
      state.createPaymentRequestObj.errorMessage = message;
    },
  },
});

export default paymentRequestSlice.reducer;

export const paymentRequestSelector = (state) => state.paymentRequest;
